import {Tabs} from 'antd'
import styled from 'styled-components'

import {media} from '@/src/config/theme'
import {Collapse} from '@/src/shared/ui/collapse'

export const ProductTabs = styled(Tabs)`
  display: none;

  & .ant-tabs-nav-list {
    gap: 6px;
    overflow-x: auto;
  }

  & .ant-tabs-tab {
    min-width: 152px;
    justify-content: center;
    font-weight: 400;

    &.ant-tabs-tab-active {
      font-weight: 450;
    }
  }

  & .ant-tabs-nav-more {
    display: none;
  }

  @media ${media.md} {
    display: block;
  }
`

export const ProductSpoilers = styled(Collapse)`
  display: block;

  & .ant-collapse-item-active {
    .ant-collapse-header {
      font-weight: 450;
    }
  }

  & .ant-collapse-arrow {
    svg {
      path {
        font-size: 16px;
      }
    }
  }

  @media ${media.md} {
    display: none;
  }
`
